import axios from "axios";

const ROOT = process.env.REACT_APP_BACKEND_URL;
const BASE = `${ROOT}/api/par`;
export const PARTNER_TOKEN_KEY = "tea_partner_token";

const client = (tokenKey) => {
  const headers = () => {
    const t = localStorage.getItem(tokenKey);
    return t ? { Authorization: `Bearer ${t}` } : {};
  };
  return {
    get: (path, params) => axios.get(`${BASE}${path}`, { headers: headers(), params }).then((r) => r.data),
    post: (path, body) => axios.post(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
    patch: (path, body) => axios.patch(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
    put: (path, body) => axios.put(`${BASE}${path}`, body, { headers: headers() }).then((r) => r.data),
    upload: (path, file) => {
      const fd = new FormData();
      fd.append("file", file);
      return axios.post(`${BASE}${path}`, fd, { headers: headers() }).then((r) => r.data);
    },
    openFile: (apiUrl) => axios.get(`${ROOT}${apiUrl}`, { headers: headers(), responseType: "blob" })
      .then((r) => window.open(URL.createObjectURL(r.data), "_blank", "noopener")),
  };
};

/** Staff (Super Admin) client for /api/par/* admin routes. */
export const parApi = client("nex_token");
/** Partner portal client — partner-only token, never the staff token. */
export const portalApi = client(PARTNER_TOKEN_KEY);

const KEY = (k) => `tea_partner_${k}`;
export const parPref = {
  get: (k, fallback) => localStorage.getItem(KEY(k)) || fallback,
  set: (k, v) => localStorage.setItem(KEY(k), v),
};

export const PARTNER_TYPES = [["volunteer_mentor", "Volunteer / Mentor"], ["agency_caseworker", "Agency Caseworker"], ["org_ambassador", "Org Ambassador"], ["pmc_lead", "PMC Lead"]];
export const typeLabel = (t) => (PARTNER_TYPES.find(([k]) => k === t) || [, t])[1];
export const parErr = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg || x).join(", ");
  return (typeof d === "string" && d) || e?.message || "Request failed";
};
